// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pill-managing-criteria-cp_wrapper__1LWeP","pill":"pill-managing-criteria-cp_pill__3N_o_","pillItem":"pill-managing-criteria-cp_pillItem__2Jg1D"};